import React, { useState } from 'react';
import { GlobeIcon } from './Icons';

const LOCALES = [
  { code: 'en', name: 'English' },
  { code: 'vi', name: 'Tiếng Việt' }
];

/**
 * Language switcher component
 * Supports both desktop (dropdown) and mobile (buttons) modes
 *
 * @param {Object} props
 * @param {boolean} props.isMobile - Whether to render in mobile mode (buttons) or desktop mode (dropdown)
 * @param {string} props.variant - 'dark' for dark backgrounds, 'light' for light backgrounds
 */
export const LanguageSwitcher = ({ isMobile = false, variant = 'dark' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentLocale = document.documentElement.lang || 'vi';

  const handleLocaleChange = (locale) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `/locale?locale=${locale}`;

    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'patch';
    form.appendChild(methodInput);

    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = document.querySelector('meta[name="csrf-token"]')?.content || '';
    form.appendChild(csrfInput);

    document.body.appendChild(form);
    form.submit();
  };

  if (isMobile) {
    // Mobile: show language options as buttons
    return (
      <div className="d-flex gap-2">
        {LOCALES.map((locale) => (
          <button
            key={locale.code}
            className={`btn btn-sm ${currentLocale === locale.code ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => handleLocaleChange(locale.code)}
          >
            {locale.name}
          </button>
        ))}
      </div>
    );
  }

  // Desktop: dropdown with globe icon
  const textColorClass = variant === 'dark' ? 'text-white' : 'text-dark';

  return (
    <div className="dropdown position-relative">
      <button
        id="languageDropdown"
        className={`btn btn-link nav-link d-flex align-items-center ${textColorClass} p-0`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <GlobeIcon />
      </button>
      {isOpen && (
        <>
          {/* Backdrop to close dropdown when clicking outside */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ zIndex: 1000 }}
            onClick={() => setIsOpen(false)}
          />
          <ul
            className="dropdown-menu dropdown-menu-end show"
            style={{ position: 'absolute', right: 0, zIndex: 1001 }}
          >
            {LOCALES.map((locale) => (
              <li key={locale.code}>
                <button
                  className={`dropdown-item ${currentLocale === locale.code ? 'active' : ''}`}
                  onClick={() => handleLocaleChange(locale.code)}
                >
                  {locale.name}
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
